const getBrigeLinkTemplateImage = (bridgeLink: string) => {
  const url = new URL(bridgeLink);
  const hostname = url.hostname;
  const pathname = url.pathname;

  if ( (/^(www\.)?pbsparents\.org$/i).test(hostname) ||
    ((/^(www\.)?pbs\.org$/i).test(hostname) && (/^\/parents(\/.*)?$/i).test(pathname))
  ) {
    return '/puma/images/logos/PBSKidsForParentsLogoReverse.svg';
  } else if ( (/^(www\.)?pbslearningmedia\.org$/i).test(hostname) ) {
    return '/puma/images/logos/PBSLmLogoOpenArea.svg';
  } else if ( (/^(www\.)?pbs\.org$/i).test(hostname) ) {
    return '/puma/images/logos/PBSLogo.svg';
  }
  return '';
};

export {
  getBrigeLinkTemplateImage,
};
